<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Копия документов
        .form-elem__body
          .achievements
            .achievements__list.achievements-list
              .achievements-list__item
                .achievement(
                  v-for="award in userAwardsData"
                )
                  .attached-file
                    button.button(
                    @click.prevent="onAddPortfollio('edit', award)"
                    )
                      .button__text {{ award.title }}
                    .attached-file__button-remove
                      button-delete(
                      @onButtonClick="onDelete(award)"
                      )
            .achievements__button-add
              button.button(
                @click.prevent="onAddPortfollio('new')"
              )
                .button__icon
                  img(src="@/assets/images/icons/clip.svg")
                .button__text Добавить документ
          .form-elem__error(
          v-if="currentErrorMessage.length > 0"
          ) {{ currentErrorMessage }}
          .form-elem__description
            | Здесь вы можете прикрепить копию сертификатов, грамот, благодарностей за участие в соревнованиях,
            | конкурсах, олимпиадах.
            | Можно добавлять только грамоты за 2020 год. Количество грамот не должно превышать 5.
            | Формат файла - jpeg, размер не должен превышать 1 Мб.
          //- &#160;1мб.
    //- .form__elem
    //-   .form-elem.form-elem_horizontal
    //-     .form-elem__title Количество баллов
    //-     .form-elem__body
    //-       .points 123
    //-       .form-elem__description Баллы насчитываются на основе уровня достижений. Чем выше достижения, тем больше баллов.
</template>

<script>
import ButtonDelete from "../../../../../components/button-delete/button-delete";
export default {
  name: "form-portfolio",
  components: { ButtonDelete },
  props: ["userAwardsData"],
  data() {
    return {
      currentErrorMessage: "",
    };
  },
  methods: {
    openModal(type, award) {
      this.$emit("onOpenModal", "awards", {
        title: "Портфолио",
        type,
        award,
      });
    },
    onDelete(award) {
      this.$emit("onDeleteAward", award);
      this.currentErrorMessage = "";
    },
    onAddPortfollio(type, award) {
      if (type === "new") {
        if (this.userAwardsData.length < 5) {
          this.openModal(type, award);
        } else {
          this.currentErrorMessage = "Вы можете добавить не более 5 грамот";
        }
      } else {
        this.openModal(type, award);
      }
    },
  },
};
</script>
